module.exports = function(text) {
    var result = parseFloat(text);
    if (!isNaN(result) && text.toString().length > 0 ){
      return result;
    } else {
      return '';
    }
};
